import { MsArrow as p } from "@sunrise/icons";
import { inViewDetector as h } from "@sunrise/shared";
import S from "scrollbooster";
import { defineComponent as E, ref as d, onMounted as _, onUnmounted as B } from "vue";
import I from "./index175.js";
import { FIRST_CLASS_LIST as f, LAST_CLASS_LIST as L } from "./index563.js";
const W = E({
  name: "MsBreadcrumb",
  components: {
    MsArrow: p,
    MsJsonLd: I
  },
  props: {
    breadcrumb: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    const e = d(null), o = d(null);
    let a, s;
    _(() => {
      var r, i;
      e.value && o.value && (a = new S({
        viewport: e.value,
        content: o.value,
        direction: "horizontal",
        scrollMode: "transform"
      })), T(e.value) && g(a, e.value), s = h.createObserver({
        root: e.value,
        threshold: 0.99,
        allEvents: !0
      });
      const u = (r = o.value) == null ? void 0 : r.firstElementChild, m = (i = o.value) == null ? void 0 : i.lastElementChild;
      s.observe(
        u,
        (c) => {
          var n, l;
          c.isIntersecting ? (n = e.value) == null || n.classList.remove(...f) : (l = e.value) == null || l.classList.add(...f);
        },
        !1
      ), s.observe(
        m,
        (c) => {
          var n, l;
          c.isIntersecting ? (n = e.value) == null || n.classList.remove(...L) : (l = e.value) == null || l.classList.add(...L);
        },
        !1
      );
    }), B(() => {
      a.destroy(), s.kill();
    });
    function b() {
      return t.breadcrumb.slice(0, t.breadcrumb.length - 1);
    }
    function v() {
      return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: t.breadcrumb.map((r, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: r.title,
          item: r.link,
          url: r.link
        }))
      };
    }
    return {
      viewport: e,
      content: o,
      jsonLd: v,
      getLinks: b
    };
  }
});
function T(t) {
  return t && t.scrollWidth > t.clientWidth;
}
function g(t, e) {
  e && t.scrollTo({ x: e.scrollWidth - e.clientWidth });
}
export {
  W as default
};
